import React from "react";

import { connect } from 'react-redux';
import { createBrowserHistory } from "history";
import { Router, Route, Switch, Redirect } from "react-router-dom";

//Componentes auxiliares:
import AuthLayout from './layouts/authLayout/AuthLayout';
import MainLayout from './layouts/mainLayout/MainLayout';
import ProtectedLayout from './tools/components/ProtectedLayout';

//Variables para el router:
const browserHistory = createBrowserHistory();

class App extends React.Component {

	constructor() {
		super();

		this.state = {

		};
	}

	render() {
		return (
			<Router history={browserHistory}>
				<Switch>
					<Route path="/auth" render={props => <AuthLayout {...props} />} />
					<ProtectedLayout path="/admin" isUserLogged={this.props.isUserLogged} Component={MainLayout} />

					<Redirect to="/auth/login" />
				</Switch>
			</Router>
		);
	}

	componentDidMount() {
		window.document.title = process.env.REACT_APP_CRAWLER_OWNER + ' Crawler';
	}

}


const mapStateToProps = state => {
	return {
		activeUser: state.mainReducer.activeUser,
		isUserLogged: state.mainReducer.isUserLogged,
	};
};

export default connect(mapStateToProps)(App);
